import PropTypes from 'prop-types';
import React from 'react';

const JsonLd = ({ data }) => {
    if (!data) {
        return null;
    }

    const json = JSON.stringify(data).replace(/</g, '\\u003c');

    return (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: json }} />
    );
};

JsonLd.propTypes = {
    data: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ])
};

export default JsonLd;
